import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { getCustomerDetailsApi } from "./setupApi";
import { Card } from "../../ui/Card";
import {
  Button,
  Chip,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { BusinessCenter } from "@mui/icons-material";
import BreadCrumbs from "../../ui/BreadCrumbs";
import { useServiceDrawer } from "../orders/useServiceDrawer";
import { StyledButton } from "../../ui/StyledButton";

export interface CustomerDetailsType {
  total_orders: number;
  total_delivered: number;
  total_rto: number;
  total_revenue: number;
  address_list: [
    {
      address: string;
      city: string;
      state: string;
      postal_code: string;
      person_name: string;
      email: string;
    }
  ];
  shipments: [
    {
      ship_id: number;
      status: string;
      shipped_date: string;
    }
  ];
}

const CustomerDetails = () => {
  const { mobileNumber } = useParams();

  const [customerData, setCustomerData] = useState<CustomerDetailsType>();

  const navigate = useNavigate();

  useEffect(() => {
    if (mobileNumber?.length !== 10) {
      toast.error("No customer exist");
      navigate("/set-up-and-management/customer_search");
    } else {
      getCustomerDetailsApi(mobileNumber)
        .then((data) => {
          setCustomerData(data?.data?.data);
        })
        .catch((error) => console.log(error));
    }
  }, []);

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <BreadCrumbs
            field="Setup"
            extra={[{ text: "Customer" }]}
            link="/set-up-and-management/customer_search"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={"600"} fontSize={"14px"} color="#000000">
            Customer Overview
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Card>
            <BusinessCenter />
            <Typography>Total Orders: {customerData?.total_orders}</Typography>
          </Card>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Card>
            <BusinessCenter />
            <Typography>
              Total Revenue: {customerData?.total_revenue}
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Card>
            <BusinessCenter />
            <Typography>
              Total Delivered: {customerData?.total_delivered}
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={6} sm={6} md={3}>
          <Card>
            <BusinessCenter />
            <Typography>Total RTO: {customerData?.total_rto}</Typography>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={"600"} fontSize={"14px"} color="#000000">
            Customer Details
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <Typography fontSize={"16px"}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Name:{" "}
              </span>
              {customerData?.address_list[0]?.person_name}
            </Typography>
            <Typography fontSize={"16px"}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Email:{" "}
              </span>
              {customerData?.address_list[0]?.email}
            </Typography>
            <Typography fontSize={"16px"}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Mobile Number:{" "}
              </span>
              {mobileNumber}
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={"600"} fontSize={"14px"} color="#000000">
            Customer Address
          </Typography>
        </Grid>
        {customerData?.address_list?.map((address, index) => {
          return (
            <Grid key={index} item xs={12} sm={6} md={4}>
              <Card>
                <Typography fontSize={"14px"}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    Address:{" "}
                  </span>
                  {address?.address}
                </Typography>
                <Typography fontSize={"14px"}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    City:
                  </span>{" "}
                  {address?.city}
                </Typography>
                <Typography fontSize={"14px"}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    State:{" "}
                  </span>
                  {address?.state}
                </Typography>
                <Typography fontSize={"14px"}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    Pincode:
                  </span>{" "}
                  {address?.postal_code}
                </Typography>
                <Typography fontSize={"14px"}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    Name:
                  </span>{" "}
                  {address?.person_name}
                </Typography>
                <Typography fontSize={"14px"}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    Email:{" "}
                  </span>
                  {address?.email}
                </Typography>

                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <StyledButton
                    onClick={() =>
                      navigate(
                        `/order/add-order?customer=${mobileNumber}&index=${index}`
                      )
                    }
                    variant="contained"
                    sx={{
                      textTransform: "none",
                    }}
                  >
                    Add Order
                  </StyledButton>
                </div>
              </Card>
            </Grid>
          );
        })}

        <Grid item xs={12}>
          <Typography fontWeight={"600"} fontSize={"14px"} color="#000000">
            Customer Orders
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TableContainer component={Card}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Order id</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Shipped Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerData?.shipments.map((order, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{order?.ship_id}</TableCell>
                      <TableCell>
                        <Chip
                          sx={{
                            padding: "1px 1px",
                          }}
                          label={order?.status}
                          variant="outlined"
                          color="success"
                        />
                      </TableCell>
                      <TableCell>{order?.shipped_date}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default CustomerDetails;
